import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Wsdefs } from '../../core/entities/wsdefs.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class WsdefsService {
    readonly BASE: any = PETICIONES.wsdefs;

    constructor(private http: HttpClient) { }

    /**
   * @description
   * Obtiene todos los wsdefs
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un wsdefs por su id
   */
  public findById(id: number): Observable<any> {
    let idwsdefs: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idwsdefs).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un wsdefs en la base de datos
   */
  public postWsdef(wsdefs: Wsdefs): Observable<any> {
    const json = JSON.stringify(wsdefs);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postWsdefs, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un wsdefs en la base de datos
   */
  public deleteWsdef(wsdefs: Wsdefs): Observable<any> {
    let idwsdefs: string = (wsdefs.id !== undefined && wsdefs.id !== null ? wsdefs.id + "" : "");
    return this.http.get(this.BASE.deleteWsdefs + "/" + idwsdefs).pipe(delay(DELAY));
  }
}